import { castArray, isFinite, isNumber } from 'lodash';
import React, { useMemo } from 'react';

import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { CircularProgress } from '@mui/material';

import { MayBeNil } from 'app/@types/utils/may-be-nil';
import { PropsOf } from 'app/@types/utils/props-of';
import Breadcrumbs from 'pages/Search/components/Breadcrumbs';
import { ROUTES } from 'pages/Search/constants';
import groupDigits from 'utils/group-digits';

import useStyles from './styles';

interface Props {
    title: string | [string, ...MayBeNil<string>[]];
    breadcrumbs: PropsOf<typeof Breadcrumbs>['items'];
    total?: MayBeNil<number>;
    className?: string;
    actions?: React.ReactNode;
}

const SectionHeading: React.FC<Props> = ({ title, total, breadcrumbs, actions, className }) => {
    const { classes, cx } = useStyles();
    const breadcrumbItems = useMemo(() => [{ to: ROUTES.SEARCH(), label: 'Database' }, ...breadcrumbs], [breadcrumbs]);
    return (
        <div className={cx(classes.root, className)}>
            <Breadcrumbs items={breadcrumbItems} />
            <div className={classes.container}>
                <div className={classes.title}>
                    {castArray(title)
                        .filter((item) => !!item)
                        .map((item, index) => (
                            <React.Fragment key={index}>
                                {index === 0 ? null : <ChevronRightRoundedIcon />}
                                <span className={classes.titleItem}>{item}</span>
                            </React.Fragment>
                        ))}
                    {isNumber(total) ? (
                        <span className={classes.total}>
                            {isFinite(total) ? groupDigits(total) : <CircularProgress size={22} thickness={5} />}
                        </span>
                    ) : null}
                </div>
                {actions}
            </div>
        </div>
    );
};

export default SectionHeading;
